import { useCallback, useEffect, useState } from 'react'

import WashBakeTooltip from '@/components/konva/components/WashBakeTooltip'
import { useAppDispatch } from '@/hooks/redux'
import { useAppSelector } from '@/store'
import {
  removeWashBakeTarget,
  setWashBakeRecipeOutput,
} from '@/store/stainingStudio'

const KonvaWashBake = () => {
  const dispatch = useAppDispatch()
  const washBake = useAppSelector((state) => state.stainingStudio.washBake)

  const canvasImage = useAppSelector((state) => state.app.canvasImage)

  const washBakeOutput = useAppSelector(
    (state) => state.stainingStudio.washBakeRecipeOutput,
  )

  const frameworkTargetColor = useAppSelector(
    (state) => state.stainingStudio.frameworkTargetColor,
  )
  const [tooltipOpenMap, setTooltipOpenMap] = useState<Record<string, boolean>>(
    {},
  )
  useEffect(() => {
    const initialTooltipState: Record<string, boolean> = {}
    Object.keys(washBake || {}).forEach((key) => {
      initialTooltipState[key] = true
    })
    setTooltipOpenMap(initialTooltipState)
  }, [canvasImage?.id, washBake])

  const handleToggleTooltip = useCallback((key: string) => {
    setTooltipOpenMap((prev) => ({ ...prev, [key]: !prev[key] }))
  }, [])

  const handleCloseTooltip = useCallback((key: string) => {
    setTooltipOpenMap((prev) => ({ ...prev, [key]: false }))
  }, [])

  const handleDeleteWashbake = useCallback(
    (washBakeKey: string) => {
      if (!canvasImage?.id) return

      dispatch(
        setWashBakeRecipeOutput({
          imageId: canvasImage?.id,
          key: washBakeKey,
          result: undefined,
        } as any),
      )
      dispatch(
        removeWashBakeTarget({
          key: washBakeKey,
        }),
      )
    },
    [dispatch, canvasImage?.id],
  )

  return (
    <>
      {Object.keys(washBake || {}).map((key) => {
        const data = frameworkTargetColor?.[key]?.imagePosition
        const output = washBakeOutput?.[canvasImage?.id]?.[key]
        if (!output) return null
        return (
          <WashBakeTooltip
            key={key}
            keyName={key}
            data={data}
            output={output}
            open={!!tooltipOpenMap[key]}
            toggle={handleToggleTooltip}
            close={handleCloseTooltip}
            onDelete={handleDeleteWashbake}
          />
        )
      })}
    </>
  )
}

export default KonvaWashBake
